import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";

import FormNewSubmitButton from './FormNewSubmitButton';
import { withStyles } from "@material-ui/core/styles";
import SavingDialog from "../dialogs/SavingDailog";
import DeletingDialog from "../dialogs/DeletingDialog";


const styles = () => {
	return {
		container: {
			display: 'flex',
			justifyContent: 'flex-start',
			alignItems: 'center',
			width: '100%',
		},
		cancel: {
			cursor: 'pointer',
			color: '#666',
			marginTop: 30,
			'&:hover': {
				color: '#555',
			}
		},
		delete: {
			cursor: 'pointer',
			color: '#b33',
			borderColor: `#b33`,
			marginTop: 30,
			marginLeft: 20,
			marginRight: 15,
			'&:hover': {
				color: '#911',
			}
		},
		submit: {
			marginLeft: 40,
		}
	}
};

class FormActions extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isSavingOpen: false,
			savingStatus: null,
			isDeletingOpen: false,
			deletingStatus: null,
		};
	}

	closeDialogs = () => {
		this.setState({
			isSavingOpen: false,
			isDeletingOpen: false,
		});
	};

	deleteClick = () => {
		this.setState({
			isDeletingOpen: true,
			deletingStatus: 'confirming',
		});
	};

	deleteConfirm = () => {
		const { onDelete, onError, minimumRequestTime } = this.props;

		let startUnix = Date.now();
		// if we were done before we showed anything so be it
		// maybe the onSave function returned some errors syncronously
		// originally the isSavingOpen would trigger first but there was a flash between the error popup
		// and the saving dialog
		this.showTimeout = setTimeout(() => {
			this.setState({
				isDeletingOpen: true,
				deletingStatus: 'deleting'
			});
		}, 5);

		onDelete({
			callback: (err) => {
				clearTimeout(this.showTimeout);
				if (err) {
					this.closeDialogs();
					onError(err);
					return;
				}

				let delay = minimumRequestTime - (Date.now() - startUnix);
				if (delay < 0) { delay = 0; }

				setTimeout(() => {
					this.setState({
						// make sure its open
						isDeletingOpen: true,
						deletingStatus: 'done',
					});
				}, delay);
			}
		});

	};

	saveClick = () => {
		const { onSave, onError, minimumRequestTime } = this.props;

		let startUnix = Date.now();
		// if we were done before we showed anything so be it
		// maybe the onSave function returned some errors syncronously
		// originally the isSavingOpen would trigger first but there was a flash between the error popup
		// and the saving dialog
		this.showTimeout = setTimeout(() => {
			this.setState({
				isSavingOpen: true,
				savingStatus: 'saving'
			});
		}, 5);

		onSave({
			callback: (err) => {
				clearTimeout(this.showTimeout);
				if (err) {
					this.closeDialogs();
					onError(err);
					return;
				}

				let delay = minimumRequestTime - (Date.now() - startUnix);
				if (delay < 0) { delay = 0; }

				setTimeout(() => {
					this.setState({
						// make sure its open
						isSavingOpen: true,
						savingStatus: 'done',
					});
				}, delay);
			}
		});
	};

	render() {
		const {
			classes,
			onCancel,
			onDelete,
			onDone,
			saveButtonText,
			cancelButtonText,
			deleteButtonText,
			saveProgressText,
			saveSuccessText,
			deleteConfirmText,
			deleteProgressText,
			deleteSuccessText,
		} = this.props;
		const {
			isSavingOpen,
			savingStatus,
			deletingStatus,
			isDeletingOpen
		} = this.state;

		return (
			<Fragment>
				<div className={classes.container}>
					<FormNewSubmitButton
						disabled={(savingStatus === 'saving')}
						onClick={this.saveClick}
						buttonText={saveButtonText}
					/>

					{onDelete &&
						<Button variant="outlined"  className={classes.delete} onClick={this.deleteClick}>
							{deleteButtonText}
						</Button>
					}

					{onCancel &&
						<Button variant="outlined" className={classes.cancel} onClick={onCancel}>
							{cancelButtonText}
						</Button>
					}

				</div>

				<SavingDialog
					open={isSavingOpen}
					status={savingStatus}
					onClose={this.closeDialogs}
					onContinue={onDone}
					processingText={saveProgressText}
					successText={saveSuccessText}
				/>
				<DeletingDialog
					open={isDeletingOpen}
					status={deletingStatus}
					onClose={this.closeDialogs}
					onCancel={this.closeDialogs}
					onConfirm={this.deleteConfirm}
					onContinue={onDone}
					confirmingText={deleteConfirmText}
					processingText={deleteProgressText}
					successText={deleteSuccessText}
				/>
			</Fragment>
		);
	}
}
FormActions.propTypes = {
	classes: PropTypes.object.isRequired,
	onSave: PropTypes.func.isRequired,
	onDone: PropTypes.func.isRequired,
	onCancel: PropTypes.func,
	onDelete: PropTypes.func,
	saveButtonText: PropTypes.string,
	saveProgressText: PropTypes.string,
	deleteConfirmText: PropTypes.string,
	deleteProgressText: PropTypes.string,
	deleteSuccessText: PropTypes.string,
	minimumRequestTime: PropTypes.number,
};
FormActions.defaultProps = {
	cancelButtonText: 'Cancel',
	deleteButtonText: 'Delete',
	saveButtonText: 'Save',
	minimumRequestTime: 400,
};

export default withStyles(styles)(FormActions);
